import lodash from 'lodash'
import moment from 'moment'

import { backendServicesToServices } from '../AdditionalServices'
import { generateTimeOptions } from '../providers/utils'
import { TOrderEntryBackendProduct, TOrderEntryProduct } from '../types'

export function parseProducts(
  products: TOrderEntryBackendProduct[],
): TOrderEntryProduct[] {
  if (!products) {
    return []
  }
  // console.log("before parsing products", products)
  const result: TOrderEntryProduct[] = lodash.map(products, (product) => {
    // separate services
    const additionalServices = lodash.values(
      lodash.get(product, 'mappedAdditionalServices', {}),
    )
    const shipmentServices = lodash.filter(
      additionalServices,
      (s) => s.level === 'shipment',
    )
    const coliServices = lodash.filter(
      additionalServices,
      (s) => s.level === 'coli',
    )
    const {
      id,
      name,
      avisTime,
      changePickupFromTimeAllowed,
      cityAppointmentRuntimeMinute,
      cityRuntimeMinute,
      defaultNeutralSenderAddress,
      deliveryAppointmentUntilTime,
      deliveryFromTime,
      deliveryType,
      deliveryUntilTime,
      description,
      isDeliveryAppointmentAllowed,
      isDispositionProduct,
      isPickupAppointmentAllowed,
      isvalueOfGoodsAllowed,
      manualPickupAppointmentStartAllowed,
      manualPickupStartAllowed,
      mappedAdditionalServices,
      neutralSenderActiveByDefault,
      neutralSenderEditable,
      neutralSendingEnabled,
      neutralSenderAddress,
      notificationOptions,
      overwriteInvoiceAddressAllowed,
      pickupAppointmentUntilTime,
      pickupFromTime,
      pickupType,
      pickupUntilTime,
      proformaInvoiceLightAllowed,
      shortcode,
      slaType,
      slaTypeId,
      timings,
      typeOfOperation,
      allowedFreightTermList,
      allowedPackagingList,
      defaultFreightTerm,
      defaultPackaging,
      hazmatAllowedUnNumberList,
      hazmatAllowedUnNumberRanges,
      isBarcodeInputAllowed,
      isColiReferenceTextHidden,
      isColiReferenceTextMandantory,
      isContentDescriptionAllowed,
      isContentRequired,
      isFreightTermsAllowed,
      isMeasurementsHidden,
      isMeasurementsOptional,
      isPackagingAllowed,
      isValueOfGoodsRequired,
      isWeightHidden,
      isWeightOptional,
      maxGirth,
      maxHeight,
      maxLength,
      maxVolume,
      maxWeight,
      maxWidth,
      reusableBoxAllowed,
      showVolumeWeight,
      volumeWeightFactor,
      eoriIsNeverMandatory,
      enableProforma,
      enableDutiableProducts,
      contentDescriptionMandatory,
      measurementsMandantory,
      recommendedTimesMayBeSet,
      isFreightCollectCheckAllowed,
      ...rest
    } = product

    const ms = moment(avisTime).valueOf() - moment().valueOf()
    const duration = moment.duration(ms)
    const isLate = duration.asSeconds() < 0

    return {
      id,
      name,
      avisTime,
      changePickupFromTimeAllowed,
      cityAppointmentRuntimeMinute,
      cityRuntimeMinute,
      defaultNeutralSenderAddress,
      deliveryAppointmentUntilTime,
      deliveryFromTime,
      deliveryType,
      deliveryUntilTime,
      description,
      isDeliveryAppointmentAllowed,
      isDispositionProduct,
      isPickupAppointmentAllowed,
      isvalueOfGoodsAllowed,
      manualPickupAppointmentStartAllowed,
      manualPickupStartAllowed,
      mappedAdditionalServices,
      neutralSenderActiveByDefault,
      neutralSenderEditable,
      neutralSendingEnabled,
      neutralSenderAddress,
      notificationOptions,
      overwriteInvoiceAddressAllowed,
      pickupAppointmentUntilTime,
      pickupFromTime,
      pickupType,
      pickupUntilTime,
      proformaInvoiceLightAllowed,
      shortcode,
      slaType,
      slaTypeId,
      timings,
      timeOptions: generateTimeOptions(product),
      typeOfOperation,
      shipmentServices: backendServicesToServices(shipmentServices),
      coliServices: backendServicesToServices(coliServices),
      disabled: isLate,
      allowedFreightTermList,
      allowedPackagingList: allowedPackagingList ?? [],
      defaultFreightTerm,
      defaultPackaging,
      hazmatAllowedUnNumberList,
      hazmatAllowedUnNumberRanges,
      isBarcodeInputAllowed,
      isColiReferenceTextHidden,
      isColiReferenceTextMandantory,
      isContentDescriptionAllowed,
      isContentRequired,
      isFreightTermsAllowed,
      isMeasurementsHidden,
      isMeasurementsOptional,
      isPackagingAllowed,
      isValueOfGoodsRequired,
      isWeightHidden,
      isWeightOptional,
      maxGirth,
      maxHeight,
      maxLength,
      maxVolume,
      maxWeight,
      maxWidth,
      reusableBoxAllowed,
      showVolumeWeight,
      volumeWeightFactor,
      eoriIsNeverMandatory,
      enableProforma,
      enableDutiableProducts,
      contentDescriptionMandatory,
      measurementsMandantory,
      recommendedTimesMayBeSet,
      isFreightCollectCheckAllowed,
      ...rest,
    }
  })
  // console.log("after parssing products", result)
  return result
}
